export default __webpack_public_path__ + "static/media/human3.a4915817.png";